import { render, staticRenderFns } from "./createLogForm.vue?vue&type=template&id=6ab09df9&"
import script from "./createLogForm.vue?vue&type=script&lang=js&"
export * from "./createLogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports